/**
 * Formats a `YYYY-MM-DD` business day as "17 de octubre".
 *
 * The day is read in Mexico City time rather than the viewer's: these are
 * billing dates anchored to that calendar, so a browser elsewhere must still
 * see the day the backend quoted.
 */
export const formatCdmxDay = (day: string): string =>
  new Date(`${day}T12:00:00Z`).toLocaleDateString('es-MX', {
    day: 'numeric',
    month: 'long',
    timeZone: 'America/Mexico_City',
  });
